import bwipjs from 'bwip-js';
import $ from 'jquery';

import { getApv, postApv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  getIframe,
  getIframeById,
  setAddEventListener,
  setIframeDisabled,
  setIframeHidden,
  setIframeInnerText,
  setModal,
  stringToHTML,
} from '../../helpers';
import { amtFormatter } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const PaymentDetails2 = {
  data: {},
  trDtlDivList: [],
  midDivList: [],
  time: 120,

  render: async () => {
    // initialize
    PaymentDetails2.data = history.state.payment;
    PaymentDetails2.trDtlDivList = history.state.trDtlDivList;

    //바코드
    return `
                    <div>
                     <a class="c_back" id="connect_pay_back_button"></a>
                 </div>
                 <div class="c_title1">결제 내역 상세 조회</div>
                 <div class="p_lr_10">
                     <table class="c_table1">
                         <thead>
                             <tr>
                                 <td colspan="2" class="text_left p_b_30"><div class="c_label4_4" id="merBizName"></div></td>
                             </tr>
                         </thead>
                         <tbody>
                         <tr id="appr">
                                 <th>
                                     <div class="c_label5_2">승인번호</div>
                                 </th>
                                 <td>
                                     <div class="c_label5_3" id="apprno"></div>
                                 </td>
                             </tr>
                             <tr>
                                 <th>
                                     <div class="c_label5_2">주문일시</div>
                                 </th>
                                 <td>
                                     <div class="c_label5_3" id="orderDtTm"></div>
                                 </td>
                             </tr>
                             <tr>
                                 <th class="p_b_30">
                                     <div class="c_label5_2">결제방법</div>
                                 </th>
                                 <td class="p_b_30">
                                     <div class="c_label5_3" id="trDtlDiv"></div>
                                 </td>
                             </tr>
                             <tr>
                                 <th class="p_b_30">
                                     <div class="c_label5_2">결제메체</div>
                                 </th>
                                 <td class="p_b_30">
                                     <div class="c_label5_3" id="mdiDivLabel"></div>
                                 </td>
                             </tr>
                             <tr>
                                 <th class="p_t_30">
                                     <div class="c_label5_2">결제요청금액</div>
                                 </th>
                                 <td class="p_t_30">
                                     <div class="c_label4_6" id="itemAmt"></div>
                                 </td>
                             </tr>
                             <tr id="tr_con_dc_amt">
                                 <th class="p_t_30">
                                     <div class="c_label5_2">커넥트페이 할인</div>
                                 </th>
                                 <td class="p_t_30">
                                     <div class="c_label4_6" id="conDcAmt"></div>
                                 </td>
                             </tr>
                             <tr>
                                 <th class="p_t_30">
                                     <div class="c_label5_2">가맹점 할인</div>
                                 </th>
                                 <td class="p_t_30">
                                     <div class="c_label4_6" id="merDcAmt"></div>
                                 </td>
                             </tr>
                             <tr>
                                 <th class="p_t_30">
                                     <div class="c_label5_2">실 승인금액</div>
                                 </th>
                                 <td class="p_t_30">
                                     <div class="c_label4_6" id="trAmt"></div>
                                 </td>
                             </tr>
                         </tbody>
                     </table>
                 </div>
                 <div class="bottom_btn_wrapper">
                     <button class="btn c_btn1 skin1_btn" id="payment_cancel_btn" data-toggle="modal" data-target="#barcode_full" >결제취소</button>
                 </div>`;
  },
  afterRender: async () => {
    // SetAlertModal
    setAlertModal();

    // initialize
    try {
      const res = await getApv('common/code?grpCode=MDI_DIV_CODE');
      if (res == null)
        throw '데이터 로드 중입니다.\n잠시 후 시도해 보세요 (1001)';
      PaymentDetails2.midDivList = res;
    } catch (e) {
      showAlertModal('오류', e.resultMessage || e);
      console.error(e.resultMessage || e);
    }

    const data = PaymentDetails2.data;
    setIframeInnerText('merBizName', data.merBizName);
    setIframeInnerText('orderDtTm', data.trDt + ' ' + data.trTm); // '2022.08.24  13:30'
    setIframeInnerText('itemAmt', amtFormatter(data.itemAmt) + '원');
    setIframeInnerText('conDcAmt', amtFormatter(data.conDcAmt) + '원');
    setIframeInnerText('merDcAmt', amtFormatter(data.merDcAmt) + '원');
    setIframeInnerText('trAmt', amtFormatter(data.trAmt) + '원');
    if (PaymentDetails2.data.trDiv % 2 == 1)
      setIframeInnerText('apprno', data.apprno);
    else setIframeHidden('appr', true);
    setIframeDisabled(
      'payment_cancel_btn',
      PaymentDetails2.data.mdiDivCode === '01' ||
        PaymentDetails2.data.trDiv % 2 != 1 ||
        PaymentDetails2.data.cnclYn === 'Y'
    );

    let trDtlDiv = '알수없음';
    for (const item of PaymentDetails2.trDtlDivList) {
      if (item.codeId === PaymentDetails2.data.trDiv) {
        trDtlDiv = item.codeName;
        break;
      }
    }
    setIframeInnerText('trDtlDiv', trDtlDiv);

    if (data.trDiv.startsWith('10')) {
      getIframe().getElementById('tr_con_dc_amt').style.display = 'none';
    } else {
      getIframe().getElementById('tr_con_dc_amt').style.display = 'compact';
    }

    let mdiDivLabel = '오프라인';
    for (const item of PaymentDetails2.midDivList) {
      if (item.codeId === PaymentDetails2.data.mdiDivCode) {
        mdiDivLabel = item.codeName;
        break;
      }
    }
    setIframeInnerText('mdiDivLabel', mdiDivLabel);

    let timer; // setInterval 변수

    // Functions
    const paymentCancel = async () => {
      const cancelCode = PaymentDetails2.data.trDiv.substring(0, 2) + '02';

      await postApv('common/rsvd/off/cancel', {
        trDiv: cancelCode,
        trUniqno: PaymentDetails2.data.trUniqno,
      })
        .then((barCodeData) => {
          getIframe().getElementById('modal_barcode_image').src = getBarcodes(
            barCodeData.barCodeData
          );
          getIframe().getElementById('modal_barcode').innerText =
            barCodeData.barCodeData;
          getIframe().getElementById('modal_qrcode_image').src = getQrcodes(
            barCodeData.barCodeData
          );
          getIframe().getElementById('modal_qrcode').innerText =
            barCodeData.barCodeData;
        })
        .catch(async (err) => {
          await showAlertModal('거래 확인', err.resultMessage, null);
          $(`iframe`).contents().find('#barcode_full').remove();
          $(`iframe`).contents().find('.modal-backdrop')[0].remove();
        });
    };

    const getBarcodes = (barCodeData) => {
      const canvas = document.createElement('canvas');
      try {
        bwipjs.toCanvas(canvas, {
          bcid: 'code128',
          text: barCodeData,
          height: 12,
        });
        return canvas.toDataURL('image/png');
      } catch (e) {
        console.error(e);
        return '';
      }
    };

    const getQrcodes = (barCodeData) => {
      const canvas = document.createElement('canvas');
      try {
        bwipjs.toCanvas(canvas, {
          bcid: 'qrcode',
          text: barCodeData,
          scale: 4,
        });
        return canvas.toDataURL('image/png');
      } catch (e) {
        console.error(e);
        return '';
      }
    };

    const setTimer = (classNm, time) => {
      timer = setInterval(() => {
        const min = parseInt(time / 60);
        const sec = String(time % 60);

        if (getIframeById() == null) {
          clearInterval(timer);
          return;
        }

        [...getIframe().getElementsByClassName(classNm)].map(
          (el) =>
            (el.innerHTML = `${min == 0 ? '00' : '0' + min}:${
              sec.length == 1 ? '0' + sec : sec
            }`)
        );
        time--;

        // timeout
        if (time < 0) {
          clearInterval(timer);
          [...getIframe().getElementsByClassName(classNm)].map(
            (el) => (el.innerHTML = '00:00')
          );
          return true;
        }
      }, 1000);
    };

    //View Draw Functions
    const setBarCodeModal = () => {
      const barcodeModalLayer = `<div class="modal fade c_modal horizontal_1 show" id="barcode_full">
                                           <div class="modal-dialog modal-dialog-centered">
                                               <div class="modal-content">
                                                   <div class="modal-header">
                                                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                           <span aria-hidden="true">&times;</span>
                                                       </button>
                                                   </div>
                                                   <div class="modal-body">
                                                       <div class="c_box m_b_20">
                                                           <div class="c_box"><a href="javascript:void(0)"  id="barcode_toggle" class="c_label3"><img src="${SDK_DOMAIN}/images/qr-code_1.svg" /> QR 보기</a></div>
                                                           <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
                                                       </div>
                                                       <div class="text_center">
                                                           <div class="m_b_20 c_bar_qr"><img id="modal_barcode_image" /></div>
                                                           <div id="modal_barcode" class="c_label4_5"></div>
                                                       </div>
                                                   </div>
                                                   <div class="modal-footer"></div>
                                               </div>
                                            </div>
                                       </div>`;
      stringToHTML(barcodeModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );

      setModal('payment_cancel_btn', 'barcode_full');
    };
    const setQrCodeModal = () => {
      const qrcodeModalLayer = `<div class="modal fade c_modal show" id="qrcode_full">
                                           <div class="modal-dialog modal-dialog-centered">
                                               <div class="modal-content">
                                                   <div class="modal-header">
                                                       <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                           <span aria-hidden="true">&times;</span>
                                                       </button>
                                                   </div>
                                                   <div class="modal-body">
                                                       <div class="c_box m_b_20">
                                                           <div class="c_box"><a href="javascript:void(0)" id="qrcode_toggle" class="c_label3"><img src="${SDK_DOMAIN}/images/barcode_1.svg" /> 바코드 보기</a></div>
                                                           <div class="c_box"><a class="c_label3 reload_img"><img src="${SDK_DOMAIN}/images/reload_1.svg" /></a> <span class="m_l_5 timer">00:00</span></div>
                                                       </div>
                                                       <div class="text_center">
                                                           <div class="m_b_20 c_bar_qr"><img id="modal_qrcode_image" /></div>
                                                           <div id="modal_qrcode" class="c_label4_5"></div>
                                                       </div>
                                                   </div>
                                                   <div class="modal-footer"></div>
                                               </div>
                                            </div>
                                       </div>`;
      stringToHTML(qrcodeModalLayer).children[0].appendAfter(
        getIframe().getElementById('layer-wrapper')
      );
      setModal('payment_cancel_btn', 'barcode_full');
    };
    //View Draw
    await setBarCodeModal();
    await setQrCodeModal();
    setAlertModal();

    setTimer('timer', PaymentDetails2.time); //클래스명 초단위

    // SetEvents
    setAddEventListener('connect_pay_back_button', () => history.back());
    setAddEventListener('payment_cancel_btn', async () => {
      await paymentCancel();
      //fade 중복 생성으로 인해 하나 제거
      $(`iframe`).contents().find('.modal-backdrop')[0].remove();
    });
    // 바코드 -> QR코드
    await setModal('qrcode_toggle', 'barcode_full');
    $(`iframe`)
      .contents()
      .find('#qrcode_full')
      .on('show.bs.modal', () => {
        $(`iframe`).contents().find('#barcode_full').modal('hide');
        $(`iframe`).contents().find('.modal-backdrop').remove();
      });

    // QR코드 -> 바코드
    await setModal('barcode_toggle', 'qrcode_full');
    $(`iframe`)
      .contents()
      .find('#barcode_full')
      .on('show.bs.modal', () => {
        $(`iframe`).contents().find('#qrcode_full').modal('hide');
        $(`iframe`).contents().find('.modal-backdrop').remove();
      });
  },
};
export default PaymentDetails2;
